<template>
  <FormField :label="label" :errors="errors" :icon="icon" :focuscb="onParentFocus" :name="name">
    <div class="input-group-container">
      <slot name="before"></slot>
      <input ref="input" :id="id" :value="modelValue" :autocomplete="name" :name="name" :type="type"
             @input="onValueChange($event.target.value)">
    </div>
  </FormField>
</template>
<script>
import FormField from './FormField.vue'
export default {
  name: 'TextFormField',
  components: {
    FormField
  },
  props: {
    label: {
      type: String,
      required: true
    },
    errors: {
      type: [Array, null, undefined],
      required: false
    },
    icon: {
      type: String,
      required: true
    },
    modelValue: {
      required: false,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
  },
  emits: ['update:modelValue'],
  methods: {
    onParentFocus(event) {
      if (event.target.getAttribute('preventFocusShift')) return
      this.$refs.input.focus()
    },
    onValueChange(value) {
      this.$emit('update:modelValue', value)
    }
  }
}
</script>